import React from "react";

const PAGE_SIZE_OPTIONS = [10, 12, 25, 50, 100];

export interface RowsPerCardSelectProps {
  value: number;
  onChange: (n: number) => void;
  label?: string;
  options?: number[];
}

export function RowsPerCardSelect({
  value,
  onChange,
  label = "Items per page",
  options,
}: RowsPerCardSelectProps) {
  const effectiveOptions = React.useMemo(() => {
    const base = options ?? PAGE_SIZE_OPTIONS;
    if (value && !base.includes(value)) {
      return [...base, value].sort((a, b) => a - b);
    }
    return base;
  }, [options, value]);

  return (
    <div className="flex items-center gap-2 flex-shrink-0">
      <label className="text-sm whitespace-nowrap text-muted-foreground">{label}</label>
      <div className="relative inline-flex items-center">
        <select
          value={value}
          aria-label={label}
          onChange={(e) => onChange(Number(e.target.value))}
          className="h-[38px] min-w-[78px] pl-2.5 pr-7 text-sm font-medium tabular-nums bg-card border border-[#e2e8f0] dark:border-white/[0.08] rounded-lg outline-none focus:ring-2 focus:ring-indigo-500/20 focus:border-indigo-500 dark:focus:border-indigo-500 transition-all appearance-none cursor-pointer"
        >
          {effectiveOptions.map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
}
